import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
} from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { BackdropCircular } from 'components';
import {
  getCustomerGiftCardTransactionsApi
} from 'api';
import { useStyles } from './styles';
import CustomerGiftCardsRow from './CustomerGiftCardsRow';


const CustomerGiftCardsTable = ({customerId}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [sortDirection, setSortDirection] = useState('desc');
  const [sortField, setSortField] = useState('created_at');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    customerGiftCardTransactions: {
      items,
      totalCount
    },
    loadingCustomerGiftCardTransactions,
    loadingGiftCardsBalance
  } = useSelector((state: IReduxState) => state.customers);

  useEffect(() => {
    getCustomerGiftCardTransactionsApi({
      dispatch,
      customerId,
      sortDirection,
      sortField,
      pageSize: rowsPerPage,
      currentPage
    });
  }, [
    sortDirection,
    sortField,
    rowsPerPage,
    currentPage,
    customerId
  ]);

  const handleRequestSort = (event, property) => {
    const isDesc = sortField === property && sortDirection === 'desc';
    setSortDirection(isDesc ? 'asc' : 'desc');
    setSortField(property);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <div className="table-container">
      <TableContainer>
        <Table aria-label="collapsible table" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'transaction_id'}
                  IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                  onClick={(event) => handleRequestSort(event, 'transaction_id')}
                >
                  <div className="px-5">
                    {'#'}
                  </div>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'created_at'}
                  IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                  onClick={(event) => handleRequestSort(event, 'created_at')}
                >
                  {'Date'}
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'action_label'}
                  IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                  onClick={(event) => handleRequestSort(event, 'action_label')}
                >
                  {'Action'}
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'balance'}
                  IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                  onClick={(event) => handleRequestSort(event, 'balance')}
                >
                  {'Balance'}
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'amount'}
                  IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                  onClick={(event) => handleRequestSort(event, 'amount')}
                >
                  {'Amount Changed'}
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'action_detail'}
                  IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                  onClick={(event) => handleRequestSort(event, 'action_detail')}
                >
                  {'Details'}
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortField === 'comment'}
                  IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                  onClick={(event) => handleRequestSort(event, 'comment')}
                >
                  {'Comments'}
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!items.length ?
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No matching transactions found.
                </TableCell>
              </TableRow>
              :
              <>
                {items.map((transaction) => (
                  <CustomerGiftCardsRow
                    key={transaction.transaction_id}
                    transaction={transaction}
                  />
                ))}
              </>
            }
          </TableBody>
        </Table>
      </TableContainer>
      {!!totalCount &&
        <TablePagination
          rowsPerPageOptions={[10, 20, 40, 80, 100]}
          component="div"
          className={classes.paginationContainer}
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={currentPage - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      }
      <BackdropCircular loading={loadingCustomerGiftCardTransactions || loadingGiftCardsBalance} />
    </div>
  );
};

export default CustomerGiftCardsTable;
